var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoto = function SvgPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.882 16.4c-.481 0-.893-.17-1.236-.514a1.685 1.685 0 0 1-.514-1.236L.134 2.4c0-.481.172-.893.514-1.236A1.685 1.685 0 0 1 1.884.651l12.25.001c.482 0 .893.172 1.236.514.343.343.514.755.514 1.236l-.002 12.25c0 .482-.171.894-.514 1.236a1.685 1.685 0 0 1-1.236.514L1.882 16.4Zm0-1.75 12.25.002.002-12.25-12.25-.001-.002 12.25Zm.876-1.75 10.5.002-3.281-4.375-2.625 3.5L5.383 9.4l-2.625 3.5Z",
    fill: "currentColor"
  })));
};
export default SvgPhoto;